// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const At_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0 0 19.5c2.017 0 4.134-.607 5.665-1.625a.75.75 0 0 0-.83-1.25c-1.273.848-3.128 1.375-4.835 1.375A8.25 8.25 0 1 1 20.25 12c0 2.48-1.02 3-1.875 3s-1.875-.52-1.875-3V8.25a.75.75 0 0 0-1.5 0v.4a4.5 4.5 0 1 0 .556 6.102c.562 1.125 1.533 1.748 2.819 1.748 2.113 0 3.375-1.682 3.375-4.5A9.76 9.76 0 0 0 12 2.25ZM12 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z',
  viewBox: '0 0 24 24',
  glyph: 'At_Stroke2_Corner0_Rounded',
})

export const At_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0 0 19.5c2.017 0 4.134-.607 5.665-1.625a.75.75 0 0 0-.83-1.25c-1.273.848-3.128 1.375-4.835 1.375A8.25 8.25 0 1 1 20.25 12c0 2.48-1.02 3-1.875 3s-1.875-.52-1.875-3V8.25a.75.75 0 0 0-1.5 0v.4a4.5 4.5 0 1 0 .556 6.102c.562 1.125 1.533 1.748 2.819 1.748 2.113 0 3.375-1.682 3.375-4.5A9.76 9.76 0 0 0 12 2.25ZM12 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z',
  viewBox: '0 0 24 24',
  glyph: 'At_Stroke2_Corner2_Rounded',
})
